import { render, staticRenderFns } from "./sl-type-category-modal.vue?vue&type=template&id=64b846ed&"
import script from "./sl-type-category-modal.vue?vue&type=script&lang=js&"
export * from "./sl-type-category-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports